export enum MenuNames {
  INDEX = 'index',
  SERVICES = 'serviços',
  GALLERY = 'galeria',
  TOURISM = 'turismo',
  ABOUT_CITY = 'sobre-a-cidade',
  CONTACT = 'contato',
}
